<template>
  <a-modal width="75%" :title="title" :visible="innerVisible" @cancel="handleCancel" cancelText="关闭"
    :okButtonProps="{ style: { display: 'none' } }">
    <a-form layout="inline">
      <a-row :gutter="12">
        <a-col :md="6" :sm="12">
          <a-form-item label="分类编号">
            <a-input v-model="query.classNo" placeholder="请输入开始、结束分类编号" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :md="6" :sm="12">
          <a-form-item label="物探点号">
            <a-input v-model="query.geophysicalPointNumber" placeholder="支持开始物探点与连接编号查询" allow-clear />
          </a-form-item>
        </a-col>
        <a-col :md="8" :sm="12">
          <a-form-item>
            <a-button type="primary" @click="loadData">查询</a-button>
            <a-button style="margin-left: 8px" @click="resetList">重置</a-button>
            <a-button type="primary" style="margin-left: 8px" @click="clearUp" v-action:clearRecycle>一键清空回收站</a-button>
            <a-button type="primary" style="margin-left: 8px" @click="ClearTheQueryData"
              v-action:clearRecycleFind>一键清空查询数据</a-button>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>

    <a-alert type="info" showIcon style="margin-bottom: 16px; margin-top: 16px">
      <template slot="message">
        <span>已选择</span>
        <a style="font-weight: 600; padding: 0 4px">{{ selectedRowKeys.length }}</a>
        <span>项</span>
        <template v-if="selectedRowKeys.length > 0">
          <a-divider type="vertical" />
          <a @click="handleClearSelection">清空选择</a>
          <a-divider type="vertical" />
          <a @click="handleRevertBatch">批量还原</a>
          <a-divider type="vertical" />
          <a @click="handleDeleteBatch">批量删除</a>
        </template>
      </template>
    </a-alert>
    <a-table ref="table" rowKey="id" size="middle" bordered :columns="columns" :loading="loading"
      :dataSource="dataSource" :pagination="pagination"
      :rowSelection="{ selectedRowKeys, onChange: handleTableSelectChange }" @change="pageChange">
      <span slot="action" slot-scope="text, record">
        <a @click="handleRevert([record.id])"> <a-icon type="redo" />还原 </a>
        <a-divider type="vertical" />
        <a @click="handleDelete([record.id])"> <a-icon type="delete" />清理 </a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
// 高度封装的请求，请务必使用 superRequest.call(this,{}) 的方式调用
// eslint-disable-next-line no-unused-vars
function superRequest (options) {
  this.loading = !!options.loading
  options.promise
    .then((res) => {
      if (res.success && typeof options.success === 'function') {
        options.success(res)
      } else {
        throw new Error(res.message)
      }
    })
    .catch((e) => {
      this.$message.warning('查询已删除的数据失败：' + (e.message || e))
    })
    .finally(() => {
      this.loading = false
    })
}

export default {
  name: 'PipeLineRecycleBinModal',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      title: '数据回收站',
      loading: false,
      innerVisible: false,
      selectedRowKeys: [],
      dataSource: [],
      query: {
        classNo: '',
        geophysicalPointNumber: '',
      },
      columns: [
        {
          title: '开始分类编码',
          dataIndex: 'startClassNo',
        },
        {
          title: '结束分类编码',
          dataIndex: 'endClassNo',
        },
        {
          title: '物探点号',
          dataIndex: 'startGeophysicalPointNumber',
        },
        {
          title: '连接点号',
          dataIndex: 'endGeophysicalPointNumber',
        },
        {
          title: '特征点',
          dataIndex: 'featurePoint',
        },
        {
          title: '附属物',
          dataIndex: 'appendage',
        },
        {
          title: '构筑物',
          dataIndex: 'structure',
        },
        {
          title: '管径',
          dataIndex: 'pipeDiameter',
        },
        {
          title: '管材',
          dataIndex: 'pipeMaterial',
        },
        {
          title: '长度',
          dataIndex: 'length',
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
        },
        { title: '操作', align: 'center', dataIndex: 'action', width: 200, scopedSlots: { customRender: 'action' } },
      ],
      url: {
        // 回收站操作，get = 获取列表；put = 取回；delete = 彻底删除
        recycleBin: '/pipe-network/gis/pipe-lines/page-recovery',
        putRecycleBin: '/pipe-network/gis/pipe-lines/resume',
        deleteRecycleBin: '/pipe-network/gis/pipe-lines/delete-recovery',
      },
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: (total) => `共 ${total} 条记录`,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50', '100', '20000'],
      },
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (val) {
        if (val) {
          this.loadData()
        }
        this.innerVisible = val
      },
    },
    innerVisible (val) {
      this.$emit('update:visible', val)
    },
  },
  methods: {
    //一键清空回收站
    clearUp () {
      this.$confirm({
        title: '清空回收站',
        content: `您确定要清空回收站吗？`,
        centered: true,
        onOk: () => {
          this.$http.put('/pipe-network/gis/pipe-lines/empty/recycle').then((res) => {

            if (res.code == 0) {
              this.$message.success('操作成功')
            }
          })
        },
      })
    },
    //一键清空查询的数据
    ClearTheQueryData () {
      this.$confirm({
        title: '清空查询的数据',
        content: `您确定要清空查询的数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put('/pipe-network/gis/pipe-lines/empty/recycle/find', { ...this.query }).then((res) => {

            if (res.code == 0) {
              this.$message.success('操作成功')
              this.query.classNo = ''
              this.query.geophysicalPointNumber = ''
              this.loadData()
            }
          })
        },
      })
    },
    //重置
    resetList () {
      this.query.classNo = ''
      this.query.geophysicalPointNumber = ''
      this.selectedRowKeys = []
      this.loadData()
    },
    pageChange (pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loadData()
    },
    loadData () {
      this.loading = true
      const params = {
        page: this.pagination.current,
        limit: this.pagination.pageSize,
        ...this.query,
      }
      this.$http
        .get(this.url.recycleBin, {
          params,
        })
        .then(({ data }) => {
          this.pagination.total = data.total ? parseInt(data.total) : 0
          this.dataSource = data.list
          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    },
    handleOk () {
      this.loadData()
      this.$emit('ok')
    },
    handleCancel () {
      this.innerVisible = false
    },
    // 还原数据
    handleRevert (userIds) {
      this.$confirm({
        title: '恢复数据',
        content: `您确定要恢复这 ${userIds.length} 条数据吗？`,
        centered: true,
        onOk: () => {
          this.$http.put(this.url.putRecycleBin, [...userIds]).then((res) => {
            if (res.code === 0) {
              this.handleOk()
              this.handleClearSelection()
              this.$message.success(`还原 ${userIds.length} 个数据成功！`)
            }
          })
        },
      })
    },
    // 彻底删除数据
    handleDelete (userIds) {
      this.$confirm({
        title: '彻底删除数据',
        content: (
          <div>
            <p>您确定要彻底删除这 {userIds.length} 个数据吗？</p>
            <p style="color:red;">注意：彻底删除后将无法恢复，请谨慎操作！</p>
          </div>
        ),
        centered: true,
        onOk: () => {
          var that = this
          // eslint-disable-next-line no-unused-vars
          const params = {
            idList: userIds,
          }
          this.$http.delete(that.url.deleteRecycleBin, { data: userIds }).then((res) => {

            if (res.code === 0) {
              this.loadData()
              this.handleClearSelection()
              this.$message.success(`彻底删除 ${userIds.length} 条数据成功！`)
            } else {
              that.$message.warning(res.message)
            }
          })
        },
      })
    },
    handleRevertBatch () {
      this.handleRevert(this.selectedRowKeys)
    },
    handleDeleteBatch () {
      this.handleDelete(this.selectedRowKeys)
    },
    handleClearSelection () {
      this.handleTableSelectChange([], [])
    },
    handleTableSelectChange (selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectionRows = selectionRows
    },
  },
}
</script>

<style lang="less" scoped></style>
